<template>
  <div style="display: flex; align-items: center; gap: 10px">
    <b-progress
      style="flex-grow: 1"
      :value="loading"
      show-progress="true"
    ></b-progress>
    <button
      @click="
        loading = 0;
        load();
      "
    >
      Reload
    </button>
  </div>

  <div>
    <b-skeleton-wrapper :loading="loading < 100">
      <template #loading>
        <div>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </div>
      </template>

      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
      commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
      velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
      cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
      est laborum.
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import BSkeleton from "@/components/b-skeleton/BSkeleton.vue";
import BSkeletonWrapper from "@/components/b-skeleton/BSkeletonWrapper.vue";
import BProgress from "@/components/BProgress.vue";

export default {
  components: { BSkeletonWrapper, BSkeleton, BProgress },
  setup() {
    const loading = ref(0.0);
    const load = () => {
      setTimeout(() => {
        loading.value += 10.0;
        if (loading.value >= 100.0) {
          loading.value = 100;
        } else {
          load();
        }
      }, 200);
    };

    onMounted(() => {
      load();
    });
    return { loading, load };
  },
};
</script>
